module.exports = __webpack_public_path__ + "static/img/logo1.53786cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/logo1.png
// module id = TDW0
// module chunks = 2